import React, { useState } from 'react';
import { authFetch } from '../utils/api';
import { getBudgetContextualStyle } from './Constants';

const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);
};

export default function SituationCell({ 
    person_id, catId, month, year, data, themeColors, onUpdate, isIncome = false, isFuture = false
}) {
    const { real_n, real_n_minus_1, budget_amount } = data || { real_n: 0, real_n_minus_1: 0, budget_amount: 0 };
    const [isFocused, setIsFocused] = useState(false);
    const [tempBudget, setTempBudget] = useState(budget_amount);

    let mainDisplayValue;
    if (isIncome) {
        mainDisplayValue = real_n !== 0 ? real_n : budget_amount;
    } else {
        mainDisplayValue = budget_amount - real_n;
    }

    const handleSave = async () => {
        try {
            await authFetch.post('/budgets', {
                person_id: person_id,
                categorie_id: catId,
                year: year,
                month: month,
                amount_budget: parseFloat(tempBudget),
                calculation_type: 'manual'
            });
            setIsFocused(false);
            onUpdate();
        } catch (err) {
            console.error(err);
        }
    };

    if (!isFocused) {
        const dynamicStyle = getBudgetContextualStyle(mainDisplayValue, isIncome, isFuture, themeColors);

        return (
            <td 
                onClick={() => { setTempBudget(budget_amount); setIsFocused(true); }}
                style={{ ...styles.cell, ...dynamicStyle, cursor: 'pointer' }}
            >
                <div style={styles.diffLabel}>{formatCurrency(mainDisplayValue)}</div>
            </td>
        );
    }

    const diffValue = tempBudget - real_n;
    const diffStyle = getBudgetContextualStyle(diffValue, isIncome, isFuture, themeColors);

    return (
        <td style={{ ...styles.cell, ...styles.cellFocused }}>
            <div style={styles.focusGrid}>
                <div style={styles.labelGroup}><small>N-1</small><span>{formatCurrency(real_n_minus_1)}</span></div>
                <div style={styles.labelGroup}><small>Réel N</small><span>{formatCurrency(real_n)}</span></div>
                <div style={styles.inputGroup}>
                    <small>Budget</small>
                    <input 
                        autoFocus
                        type="number" 
                        value={tempBudget}
                        onChange={(e) => setTempBudget(e.target.value)}
                        onBlur={handleSave}
                        onKeyDown={(e) => e.key === 'Enter' && handleSave()}
                        style={styles.miniInput}
                    />
                </div>
                <div style={{ ...styles.labelGroup, color: diffStyle.color }}>
                    <small>Diff</small>
                    <strong>{formatCurrency((diffValue))}</strong>
                </div>
            </div>
        </td>
    );
}

const styles = {
    cell: { padding: '5px', border: '1px solid #ddd', textAlign: 'center', minWidth: '80px', height: '40px' },
    cellFocused: { minWidth: '150px', backgroundColor: '#fff', boxShadow: '0 0 10px rgba(0,0,0,0.2)', position: 'relative', zIndex: 10 },
    diffLabel: { fontWeight: 'bold', fontSize: '0.9em' },
    focusGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px', fontSize: '0.75em' },
    labelGroup: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
    inputGroup: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
    miniInput: { width: '60px', fontSize: '1em', textAlign: 'center', border: '1px solid #ccc', borderRadius: '3px' }
};